/** Practical single-address check (not full RFC 5322). */
const EMAIL_RE =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export const EMAIL_FORMAT_ERROR = "Enter a valid email address.";
export const PHONE_FORMAT_ERROR = "Enter a valid 10-digit US phone number.";

/**
 * @param {string} value - raw or trimmed; empty after trim is valid
 */
export function isValidEmail(value) {
  const t = String(value ?? "").trim();
  if (!t) return true;
  return EMAIL_RE.test(t);
}

/**
 * US/NANP: 10 digits, or 11 starting with 1. Empty after trim is valid.
 * @param {string} value
 */
export function isValidPhone(value) {
  const t = String(value ?? "").trim();
  if (!t) return true;
  const digits = t.replace(/\D/g, "");
  if (digits.length === 10) return true;
  if (digits.length === 11 && digits.startsWith("1")) return true;
  return false;
}
